export { default } from './PostPreview';



// WEBPACK FOOTER //
// ./src/components/PostPreview/index.js